import { render, staticRenderFns } from "./PackingSlipModal.vue?vue&type=template&id=16671353&"
import script from "./PackingSlipModal.vue?vue&type=script&lang=js&"
export * from "./PackingSlipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports